import baseUrl from '../../../utils/baseUrl';
import getToken from '../../../utils/getToken';

export const rejectReview = async (reviewId: string) => {
  const response = await fetch(`${baseUrl()}/api/v1/reviews/${reviewId}/reject`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    }
  });
  return response;
};

export const confirmReview = async (reviewableId: string) => {
  const response = await fetch(`${baseUrl()}/api/v1/trading_photo_cards/${reviewableId}/confirm`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    }
  });
  return response;
};
